import { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { toast } from "react-toastify";
import { insertCommentForPost } from "Redux/Actions";
import "./style.scss";
const Index = ({ id }) => {
  const [comment, setComment] = useState("");

  const accessToken = useSelector((state) => state.auth.accessToken);

  const { push } = useHistory();

  const submitAddComment = (e) => {
    e.preventDefault();
    if (accessToken) {
      if (comment.trim() !== "") {
        insertCommentForPost(id, comment);

        setComment("");
      } else {
        toast("لظفا فیلد نظر را پر کنید", { type: "warning" });
      }
    } else {
      toast("ابتدا وارد شوید", { type: "warning" });
      push("/sign-in");
    }
  };
  const changeComment = (e) => {
    setComment(e.target.value);
  };
  return (
    <div className=" d-flex justify-content-between align-items-center flex-column my-5">
      <form action="" className="form-add-comment " onSubmit={submitAddComment}>
        <div className="text-comment d-flex justify-content-start align-items-center  ">
          <label
            htmlFor="u-comment"
            className="  w-25 d-flex justify-content-center align-items-center"
          >
            نظر شما :
          </label>
          <textarea
            type="text"
            id="u-comment"
            className="input-add-comment p-2 w-75 rounded"
            onChange={changeComment}
            value={comment}
          />
        </div>
        <button
          className="btn align-self-end bg-info text-white mt-2"
          onClick={submitAddComment}
        >
          ثبت نظر
        </button>
      </form>
    </div>
  );
};

export default Index;
